'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.createLogicalExpression = createLogicalExpression;
exports.createAndExpression = createAndExpression;
exports.createOrExpression = createOrExpression;
exports.createNotExpression = createNotExpression;

var _hasLength2 = require('@oigroup/lightscript-runtime/hasLength');

var _hasLength3 = _interopRequireDefault(_hasLength2);

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _getSurroundingLoc = require('ast-loc-utils/lib/getSurroundingLoc');

var _getSurroundingLoc2 = _interopRequireDefault(_getSurroundingLoc);

var _placeAtLoc = require('ast-loc-utils/lib/placeAtLoc');

var _placeAtLoc2 = _interopRequireDefault(_placeAtLoc);

var _placeAtNode = require('ast-loc-utils/lib/placeAtNode');

var _placeAtNode2 = _interopRequireDefault(_placeAtNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isArray = Array.isArray;
function createLogicalExpression(operator) {
  for (var _len = arguments.length, conditions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    conditions[_key - 1] = arguments[_key];
  }

  if (conditions.length === 1 && isArray(conditions[0])) {
    conditions = conditions[0];
  }
  if ((0, _hasLength3.default)(conditions, 0, 0)) {
    if (operator === "&&") return _types2.default.booleanLiteral(true);else return _types2.default.booleanLiteral(false);
  } else if ((0, _hasLength3.default)(conditions, 1, 1)) {
    var _conditions = conditions,
        _conditions2 = _slicedToArray(_conditions, 1),
        _oneCondition = _conditions2[0];

    return _oneCondition;
  } else {
    return (0, _placeAtLoc2.default)(_types2.default.logicalExpression(operator, conditions[0], createLogicalExpression(operator, conditions.slice(1))), (0, _getSurroundingLoc2.default)(conditions));
  }
}function createAndExpression() {
  for (var _len2 = arguments.length, conditions = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    conditions[_key2] = arguments[_key2];
  }

  if (conditions.length === 1 && isArray(conditions[0])) {
    conditions = conditions[0];
  }return createLogicalExpression("&&", conditions);
}function createOrExpression() {
  for (var _len3 = arguments.length, conditions = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    conditions[_key3] = arguments[_key3];
  }

  if (conditions.length === 1 && isArray(conditions[0])) {
    conditions = conditions[0];
  }return createLogicalExpression("||", conditions);
}function createNotExpression(condition) {
  return (0, _placeAtNode2.default)(_types2.default.unaryExpression("!", condition), condition);
}


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/helpers/logical.js
// module id = 1003
// module chunks = 0